import {
  Box,
  Center,
  Flex,
  Image,
  Spacer,
  Text,
  useColorMode,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuItemOption,
  MenuGroup,
  MenuOptionGroup,
  MenuDivider,
  useMediaQuery,
} from "@chakra-ui/react";
import { RiHeartLine, RiShoppingBagLine } from "react-icons/ri";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
// import { Link } from '@chakra-ui/react'
import { nikeLogo } from "./constants/images";
import { useNavigate } from "react-router-dom";
import {  useSelector } from 'react-redux'
import { Category, NavIcon,SearchBox } from "./navbar/CategoryAndIcon";
import { SideDrawer } from "./navbar/SideDrawer";
// import { Login_failed } from "../redux/auth/action";
import { useEffect, useState } from "react";
import axios from "axios";
import { Login_failed, Login_success } from '../redux/auth/action'


export const Navbar = () => {

{/*const { token } = useSelector((state) => state.authReducer);*/}
{/*const { orderSummary } = useSelector((state) => state.cartReducer);*/}
// const cartq=JSON.parse(localStorage.getItem("nikeprod")).length
const fullData=useSelector((storeData)=>{
  return storeData.productReducer.cart
})
const [qty,setQty]=useState([]);
const [name,setName]=useState("");
const auth=useSelector((store)=>store.authred.isAuth)
const details=useSelector((store)=>store.authred.token)
const navigate = useNavigate();
const dispatch=useDispatch();
const handlePath = () => {
  navigate("/allProducts");
};
const handleLogin=()=>{
  navigate("/login")
}
const handleLogout=()=>{
  localStorage.removeItem("isLogged")
  dispatch(Login_failed())
  navigate("/")
}
useEffect(()=>{
  const token2=localStorage.getItem("isLogged");
  console.log(token2);
  if(token2){
    axios.defaults.headers.common['Authorization'] = `Bearer ${token2}`;
    async function getQ(){
      let k=await axios.get("https://real-cyan-rooster-ring.cyclic.app/getfromcart")
      console.log(k.data.nikeprod.length);
      console.log(k.data.nikeprod);
      setQty(k.data.nikeprod)
    }
    getQ();

  }
},[fullData])
useEffect(()=>{
  const token=localStorage.getItem("isLogged");
  console.log(token);
  if(token){
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    async function getP(){
      let k=await axios.get("https://real-cyan-rooster-ring.cyclic.app/profile")
      console.log(k.data);
      if(k.data.fname){
        dispatch(Login_success(token));

      }
      setName(k.data.fname)
    }
    getP();

  }
},[auth])
  const [isLargerThanSm] = useMediaQuery("(min-width: 640px)");
  return (
    <>
      {isLargerThanSm && (
      <Box h={"36px"} bg={"#f5f5f5"}>
        <Center
          h={"36px"}
          justifyContent={"right"}
          mr={"40px"}
          fontSize={"16px"}
          cursor={"pointer"}
        > 
        {/* {console.log(details)} */}
          <Menu >
          <MenuButton  px={2} size='sm' bg={'transparent'}  _hover={{ bg: 'gray.400' }} onClick={handlePath}>
                Find a Store |
              </MenuButton>
          <MenuButton  px={2} size='sm' bg={'transparent'}  _hover={{ bg: 'gray.400' }}>
                Help |
              </MenuButton>
              {auth?<MenuButton  size='sm' bg={'transparent'}  _hover={{ bg: 'gray.400' }}>
                {name} |
              </MenuButton>:""}

              {!auth?<MenuButton onClick={handleLogin} size='sm' bg={'transparent'}  _hover={{ bg: 'gray.400' }}>
                Sign In
              </MenuButton>:<MenuButton onClick={handleLogout} size='sm' bg={'transparent'}  _hover={{ bg: 'gray.400' }}>
                Logout
              </MenuButton>}
          
              
        </Menu>
         
         {/* Here paste your auth Sign up link below line is example*/}
         {/*!token ? <Auth /> : <Logout />*/}

          
        </Center>
      </Box>
     )}
     

      <Flex h={"60px"} flexDirection={"row"} px={"20px"}>
        <Box w={"80px"}>
          <Link to={"/"}>
            <Image w={"80px"} h={"60px"}  src={nikeLogo} />
          </Link>
        </Box>

        <Spacer />

        <Box display={["none", "none", "flex", "flex", "flex"]}>
          <Category
            name={"/"}
            text={"New & Featured"}
            link={"/"}
          />
          <Category
            
            name={"allProducts"}
            text={"All Products"}
            link={"/allProducts"}
          />
          <Category
            
            name={"men"}
            text={"Men"}
            link={"/men"}
          />
          <Category
            
            name={"women"}
            text={"Women"}
            link={"women"}
          />
          <Category
            
            name={"kids"}
            text={"Kids"}
            link={"/kids"}
          />
        </Box>

        <Spacer />

        <Center position={"relative"} mr={"10px"}>
          <SearchBox/>
        </Center>

        <Center position={"relative"} mr={"10px"}>
          <Link to={"/favourite"}>
            <NavIcon iconName={RiHeartLine} />
          </Link>
        </Center>

        <Center position={"relative"} mr={"10px"}>
          <Link to={"/cart"}>
            <NavIcon iconName={RiShoppingBagLine} />
            <Box
              position={"absolute"}
              top={0.5}
              right={-0.4}
              borderRadius={"50%"}
              width={"25px"}
              height={"25px"}
              textAlign={"center"}
              zIndex={-1}
              bg='#c00'
              display={"flex"}
              flexDirection="column"
              alignContent={"center"}
              justifyContent={"center"}
              color={"white"}
              opacity={0.89}
            >
              <Text> {qty.length}</Text>
              {/* {!auth?<Text> 0</Text>:<Text> {qty}</Text>} */}
            </Box>
          </Link>
        </Center>

        <Box display={["flex", "flex", "none", "none", "none"]}>
          <Center mr={"10px"}>
            <SideDrawer  />
          </Center>
        </Box>
      </Flex>

      <Box h={["10px", "10px", "10px", "10px", "10px"]}></Box>
    </>
  );
};

export default Navbar;
